import { ChevronDownIcon } from "@heroicons/react/outline";
import { AnimatePresence, motion } from "framer-motion";
import * as React from "react";
import { Box } from "../Box";
import type { IconSizeValue } from "../Icon";
import { Icon } from "../Icon";

// TODO: enhance this component with directions - for now only the "down" is required
type ArrowAnimatedIndicatorProps = {
  size?: IconSizeValue;
  //   direction: "bottom" | "left" | "right" | "top";
  color?: "caution" | "critical" | "info" | "positive" | "white";
  children: React.ReactNode;
};

const ArrowAnimatedIndicator = (props: ArrowAnimatedIndicatorProps) => {
  return (
    <Box position="relative">
      <AnimatePresence>
        <motion.div
          style={{
            left: "calc(50% - 14px)",
            // centering the arrow
            position: "absolute",
            top: "-32px",
            zIndex: 0, // impôrtant to avoid the arrow to overflow the buttons (as for zIndex: 1 on the div bellow )
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            // repeat: Infinity // uncomment this to test it
          }}
          initial={{ opacity: 0, top: "-250px" }}
          animate={{ opacity: [0, 1, 0], top: ["-250px", "-32px"] }}
          exit={{ display: "none", opacity: 0, top: "-32px" }}
        >
          <Icon
            color={props.color ?? "positive"}
            css={{
              transform: "scale(4)",
            }}
            size={props.size ?? "large"}
            label="direction arrow"
          >
            <ChevronDownIcon />
          </Icon>
        </motion.div>
      </AnimatePresence>
      <div style={{ position: "relative", zIndex: 1 }}>{props.children}</div>
    </Box>
  );
};

export type { ArrowAnimatedIndicatorProps };
export { ArrowAnimatedIndicator };
